/** Function to calculate new target offset for smooth scrolling with lazyloaded images */
function smoothScrollTo(scrollToBtn, duration) {
    const href = scrollToBtn.getAttribute('href');
    const target = document.querySelector(href);

    if(!target) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        return;
    }

    const startTime = performance.now();

    function step() {
        const currentTime = performance.now();
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);

        const header = document.querySelector('.js-header') ? document.querySelector('.js-header').clientHeight : 0;

        const targetOffset = target.getBoundingClientRect().top + window.scrollY - header;

        const newPosition = (targetOffset - window.scrollY) * progress + window.scrollY;

        window.scrollTo(0, newPosition);

        if (progress < 1) {
            requestAnimationFrame(step);
        }
    }

    requestAnimationFrame(step);
}

/** Smooth scrolling to target section */
document.querySelectorAll('.js-scroll-btn').forEach( scrollToBtn => {
    scrollToBtn.addEventListener('click', e => {
        e.preventDefault();
        smoothScrollTo(scrollToBtn, 1000);
    })
})